import React from 'react'
import {KTSVG} from '../../../../../../../template/_metronic/helpers'

type Props = {
  className?: string
  onNext?: () => void
  onPrev?: () => void
  onSubmit?: () => void
  isLoading: boolean
}

export const StepFooter = ({className, onNext, onPrev, onSubmit, isLoading}: Props) => {
  return (
    <div className={`d-flex flex-stack flex-wrap ${className}`}>
      <div className='mr-2'>
        <button
          type='button'
          className='btn btn-light-primary-dark me-3 mb-3'
          data-kt-stepper-action='previous'
          onClick={() => {
            if (!onPrev) return
            onPrev()
          }}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-4 me-1' />
          Regresar
        </button>
      </div>
      <button
        type='button'
        className='btn btn-primary mb-3'
        data-kt-stepper-action='next'
        onClick={() => {
          if (!onNext) return
          onNext()
        }}
        disabled={isLoading}
      >
        Continuar
        <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-3 ms-2 me-0' />
      </button>
      <button
        type='submit'
        className='btn btn-primary me-3 mb-3'
        data-kt-stepper-action='submit'
        onClick={() => {
          if (!onSubmit) return
          onSubmit()
        }}
        disabled={isLoading}
      >
        Aceptar
      </button>
    </div>
  )
}
